import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MinusOutlinedSvg from "@ant-design/icons-svg/es/asn/MinusOutlined";
import AntdIcon from "../components/AntdIcon";
var MinusOutlined = function MinusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MinusOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MinusOutlined.displayName = 'MinusOutlined';
}
export default /*#__PURE__*/React.forwardRef(MinusOutlined);